import { memo } from 'react';

import IntegerInput from 'components/field/IntegerInput';

import * as S from './FilterInput.styled';

/**
 * @author Burak Unsal
 */
const DynamicListFloatInput = (props) => {
	const { value, setValue, onEnterKeyDown, autoFocus = true, className, ...moreProps } = props;

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			onEnterKeyDown && onEnterKeyDown();
		}
	};

	return (
		<S.InputContainer className={`table-float-input-container ${className ? className : ''}`} {...moreProps}>
			<IntegerInput
				autoFocus={autoFocus}
				placeholder="min"
				allowNegativeValues
				value={value?.min ?? ''}
				setValue={(val) => {
					if (!!val || val === 0 || !!value?.max || value?.max === 0) {
						setValue({
							min: val === '' ? undefined : val,
							max: value?.max
						});
					} else {
						setValue('');
					}
				}}
				onKeyDown={handleKeyDown}
				className="table-float-input"
				showArrows={false}
			/>
			<IntegerInput
				placeholder="max"
				allowNegativeValues
				value={value?.max ?? ''}
				setValue={(val) => {
					if (!!val || val === 0 || !!value?.min || value?.min === 0) {
						setValue({
							min: value?.min,
							max: val === '' ? undefined : val
						});
					} else {
						setValue('');
					}
				}}
				onKeyDown={handleKeyDown}
				className="table-float-input"
				showArrows={false}
			/>
		</S.InputContainer>
	);
};

export default memo(DynamicListFloatInput);
